import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

export const GROUP_SIZE_EVENT = "pfvr:group-size";

const GroupSizeSelector = () => {
  const { language } = useLanguage();
  const t = translations[language].groupSize;
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (option: string) => {
    setSelected(option);
    window.dispatchEvent(
      new CustomEvent(GROUP_SIZE_EVENT, { detail: `${t.prefill} ${option}.` })
    );
  };

  const goToForm = () => {
    document.getElementById("contact-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-14 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-black tracking-tight mb-4">{t.title}</h2>
          <p className="text-base text-muted-foreground mb-10">{t.subtitle}</p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
            {t.options.map((option) => {
              const isActive = selected === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => handleSelect(option)}
                  aria-pressed={isActive}
                  className={`px-6 py-4 rounded-md border text-sm sm:text-base transition-colors ${
                    isActive
                      ? "border-primary text-primary font-semibold"
                      : "border-border text-muted-foreground hover:border-primary/60 hover:text-foreground"
                  }`}
                >
                  <span className="inline-flex items-center gap-2">
                    {isActive && <Check className="w-4 h-4" />}
                    {option}
                  </span>
                </button>
              );
            })}
          </div>

          {selected && (
            <Button
              size="lg"
              onClick={goToForm}
              className="bg-primary text-primary-foreground font-semibold px-10 py-6 hover:bg-primary/90 transition-colors group"
            >
              {t.cta}
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default GroupSizeSelector;
